import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { ListItemProps } from './types';

const ListItem = forwardRef<HTMLElement, ListItemProps>(({ children, ...restProps }: ListItemProps, ref) => (
  <Box ref={ref} as="li" {...restProps}>
    {children}
  </Box>
));

ListItem.displayName = 'ListItem';

export default ListItem;
